import { useState } from "react";

import { Grid, TextField } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField, IconAutocomplete } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING } from "../../../../lib/ui/dialogFormLayout";
import { ENTITY_STATUS_OPTIONS } from "../../../../lib/ui/iconSelectOptions";
import { useTranslation } from "react-i18next";

const CreatePlanDialogBody = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState("ACTIVE");

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.plan")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField required fullWidth name="name" label={t("common.name")} size="small" />
          </Grid>
          <Grid size={12}>
            <TextField required fullWidth name="description" label={t("common.description")} rows={2} multiline size="small" />
          </Grid>
          <Grid size={12}>
            <IconAutocomplete
              options={ENTITY_STATUS_OPTIONS}
              value={status}
              onChange={(value) => setStatus(value || "ACTIVE")}
              label={t("common.status")}
              required
              disableClearable
            />
            <FormHiddenField name="status" value={status} />
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("plans.chatLimits")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="chatDailyLimit" label={t("plans.daily")} size="small" inputProps={{ min: -1 }} />
          </Grid>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="chatWeeklyLimit" label={t("plans.weekly")} size="small" inputProps={{ min: -1 }} />
          </Grid>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="chatMonthlyLimit" label={t("plans.monthly")} size="small" inputProps={{ min: -1 }} />
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("form.mailLimits")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="mailDailyLimit" label={t("plans.daily")} size="small" inputProps={{ min: -1 }} />
          </Grid>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="mailWeeklyLimit" label={t("plans.weekly")} size="small" inputProps={{ min: -1 }} />
          </Grid>
          <Grid size={4}>
            <TextField required fullWidth type="number" name="mailMonthlyLimit" label={t("plans.monthly")} size="small" inputProps={{ min: -1 }} />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default CreatePlanDialogBody;
